module.exports = {
  title: '收费标准-增值服务管理',
  route: {
    path: '/merchant-manage',
    children: {
      path: 'increment-service-config',
    },
  },
};
